import { useQuery } from "@tanstack/react-query";
import { GET_NOTIFICATIONS, getNotifications } from "..";

export const useNotificationQuery = ({ load = false }) => {
  const notificationsQuery = useQuery({
    queryKey: [GET_NOTIFICATIONS],
    queryFn: getNotifications,
    enabled: load,
  });
  return {
    notificationsQuery,
  };
};
